import React from 'react';
import { WeaTools } from 'ecCom';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import { ELEMENT_TYPES } from '../constants/ActionTypes';

import Loadable from 'react-loadable';
const loadable = (loader, loading = () => null) => Loadable({ loader, loading });

const Workflow = loadable(() => import('./workflow'));
const MyCalendar = loadable(() => import('./mycalendar'));
const Rss = loadable(() => import('./rss'));
const CustomPage = loadable(() => import('./custompage'));
const News = loadable(() => import('./news'));
const ReportForm = loadable(() => import('./reportform'));
const OutData = loadable(() => import('./outdata'));
const FormModeCustomSearch = loadable(() => import('./formmodecustomsearch'));
const Picture = loadable(() => import('./picture'));
const View = loadable(() => import('./view'));
const MoreNews = loadable(() => import('./morenews'));
const Stock = loadable(() => import('./stock'));
const Magazine = loadable(() => import('./magazine'));
const DocContent = loadable(() => import('./doccontent'));
const Audio = loadable(() => import('./audio'));
const Favourite = loadable(() => import('./favourite'));
const Flash = loadable(() => import('./flash'));
const ImgSlide = loadable(() => import('./imgslide'));
const DataCenter = loadable(() => import('./datacenter'));
const Video = loadable(() => import('./video'));
const Weather = loadable(() => import('./weather'));
const OutterSys = loadable(() => import('./outtersys'));
const Scratchpad = loadable(() => import('./scratchpad'));
const Slide = loadable(() => import('./slide'));
const JobsInfo = loadable(() => import('./jobsinfo'));
const SearchEngine = loadable(() => import('./searchengine'));
const CustomMenu = loadable(() => import('./custommenu'));
const Notice = loadable(() => import('./notice'));
const Mail = loadable(() => import('./mail'));
const CoreMail = loadable(() => import('./coremail'));
const BlogStatus = loadable(() => import('./blogstatus'));
const Contacts = loadable(() => import('./contacts'));
const AddWf = loadable(() => import('./addwf'));
const Task = loadable(() => import('./task'));
const NewNotice = loadable(() => import('./newnotice'));
const WorkTask = loadable(() => import('./worktask'));
const FnaBudgetAssistant = loadable(() => import('./fnaBudgetAssistant'));
const FnaBudgetAssistant1 = loadable(() => import('./fnaBudgetAssistant1'));
const NoReact = loadable(() => import('./noreact'));
const Cooperation = loadable(() => import('./cooperation'));
const MeetingCalendar = loadable(() => import('./meetingcalendar'));
const MyProjects = loadable(() => import('./myprojects'));
const LoginNews = loadable(() => import('./loginnews'));
const Login = loadable(() => import('./login'));
const NewMeeting = loadable(() => import('./newmeeting'));
const DayPlan = loadable(() => import('./dayplan'));
const ProcessTask = loadable(() => import('./processtask'));
const UnreadDocs = loadable(() => import('./unreaddocs'));
const NewCustomers = loadable(() => import('./newcustomers'));
const MessageReminding = loadable(() => import('./messagereminding'));
const News_dy = loadable(() => import('./news_dy'));
const CustomElement = loadable(() => import('./customelement'));
const QuickEntry = loadable(() => import('./quickentry'));
const EcodeElement = loadable(() => import('./ecodeelement'));
const OdocCenter = loadable(() => import('./odoccenter'));
const RankingList = loadable(() => import('./rankinglist'));
const TimeLine = loadable(() => import('./timeline'));

export default class Element extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            fontSizeMp: {}
        }
        this.getElementStyle = this.getElementStyle.bind(this);
    }

    getElementStyle(id, fontSizeMp){
        const { config } = this.props;
        const { eid } = config.item;
        if(!isEmpty(fontSizeMp) && id == eid){
            this.setState({
                fontSizeMp: fontSizeMp
            })
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
    }

    render() {
        const { config } = this.props;
        const { fontSizeMp } = this.state;
        const { eid, ebaseid } = config.item;
        if (/^Custom_/.test(ebaseid)) {
            return <CustomElement ecId={`${this && this.props && this.props.ecId || ''}_CustomElement@7pui54`} key={eid} config={config}/>
        }

        switch (ebaseid) {
            case ELEMENT_TYPES.WORKFLOW:
                return <Workflow ecId={`${this && this.props && this.props.ecId || ''}_Workflow@2ndq70`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.RSS:
                return <Rss ecId={`${this && this.props && this.props.ecId || ''}_Rss@c0crvw`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.CUSTOMPAGE:
                return <CustomPage ecId={`${this && this.props && this.props.ecId || ''}_CustomPage@4e100g`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NEWS:
                return <News ecId={`${this && this.props && this.props.ecId || ''}_News@zcz9yo`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.REPORTFORM:
                return <ReportForm ecId={`${this && this.props && this.props.ecId || ''}_ReportForm@h9z4mx`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.OUTDATA:
                return <OutData ecId={`${this && this.props && this.props.ecId || ''}_OutData@jcyijs`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.FORMMODECUSTOMSEARCH:
                return <FormModeCustomSearch ecId={`${this && this.props && this.props.ecId || ''}_FormModeCustomSearch@p0ne8e`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            //case ELEMENT_TYPES.MESSAGE_REMINDING:
            //case ELEMENT_TYPES.NEW_CUSTOMERS:
            //case ELEMENT_TYPES.NEW_MEETING:
            case ELEMENT_TYPES.MONTH_TARGET:
            //case ELEMENT_TYPES.DAY_PLAN:
            case ELEMENT_TYPES.SUBSCRIBE_KONWLEDG:
                //case ELEMENT_TYPES.UNREAD_DOCS:
                //case ELEMENT_TYPES.UNREAD_COOPERATION:
                //case ELEMENT_TYPES.MY_PROJECTS:
                return <View ecId={`${this && this.props && this.props.ecId || ''}_View@dctoov`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.PICTURE:
                return <Picture ecId={`${this && this.props && this.props.ecId || ''}_Picture@ykws7q`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MORE_NEWS:
                return <MoreNews ecId={`${this && this.props && this.props.ecId || ''}_MoreNews@403cxp`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.STOCK:
                return <Stock ecId={`${this && this.props && this.props.ecId || ''}_Stock@jg69qh`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MAGAZINE:
                return <Magazine ecId={`${this && this.props && this.props.ecId || ''}_Magazine@f7ym68`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.DOC_CONTENT:
                return <DocContent ecId={`${this && this.props && this.props.ecId || ''}_DocContent@09rswr`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.AUDIO:
                return <Audio ecId={`${this && this.props && this.props.ecId || ''}_Audio@lk02wb`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.FAVOURITE:
                return <Favourite ecId={`${this && this.props && this.props.ecId || ''}_Favourite@ulccbh`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.FLASH:
                return <Flash ecId={`${this && this.props && this.props.ecId || ''}_Flash@tuizp5`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.IMGSLIDE:
                return <ImgSlide ecId={`${this && this.props && this.props.ecId || ''}_ImgSlide@u0eetk`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.DATACENTER:
                return <DataCenter ecId={`${this && this.props && this.props.ecId || ''}_DataCenter@xtj6hi`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.VIDEO:
                return <Video ecId={`${this && this.props && this.props.ecId || ''}_Video@jfwhk1`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.WEATHER:
                return <Weather ecId={`${this && this.props && this.props.ecId || ''}_Weather@mzrb9q`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.OUTTERSYS:
                return <OutterSys ecId={`${this && this.props && this.props.ecId || ''}_OutterSys@zklr0p`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.SCRATCHPAD:
                return <Scratchpad ecId={`${this && this.props && this.props.ecId || ''}_Scratchpad@wkgqpp`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.SLIDE:
                return <Slide ecId={`${this && this.props && this.props.ecId || ''}_Slide@1zjynf`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.JOBSINFO:
                return <JobsInfo ecId={`${this && this.props && this.props.ecId || ''}_JobsInfo@ddkgye`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.SEARCHENGINE:
                return <SearchEngine ecId={`${this && this.props && this.props.ecId || ''}_SearchEngine@y1o5x6`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.CUSTOMMENU:
                return <CustomMenu ecId={`${this && this.props && this.props.ecId || ''}_CustomMenu@8dbqll`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NOTICE:
                return <Notice ecId={`${this && this.props && this.props.ecId || ''}_Notice@b5txrt`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MAIL:
                return <Mail ecId={`${this && this.props && this.props.ecId || ''}_Mail@4wkewj`} key={eid} config={config} fontSizeMp={fontSizeMp} />
            case ELEMENT_TYPES.COREMAIL:
                return <CoreMail ecId={`${this && this.props && this.props.ecId || ''}_CoreMail@5d29ov`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.BLOGSTATUS:
                return <BlogStatus ecId={`${this && this.props && this.props.ecId || ''}_BlogStatus@b6birp`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.CONTACTS:
                return <Contacts ecId={`${this && this.props && this.props.ecId || ''}_Contacts@hwsg9p`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.ADDWF:
                return <AddWf ecId={`${this && this.props && this.props.ecId || ''}_AddWf@fygcum`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.TASK:
                return <Task ecId={`${this && this.props && this.props.ecId || ''}_Task@swbbfj`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NEWNOTICE:
                return <NewNotice ecId={`${this && this.props && this.props.ecId || ''}_NewNotice@fj20eb`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.WORKTASK:
                return <WorkTask ecId={`${this && this.props && this.props.ecId || ''}_WorkTask@81s4pp`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.FNABUDGETASSISTANT:
                return <FnaBudgetAssistant ecId={`${this && this.props && this.props.ecId || ''}_FnaBudgetAssistant@320r9c`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.FNABUDGETASSISTANT1:
                return <FnaBudgetAssistant1 ecId={`${this && this.props && this.props.ecId || ''}_FnaBudgetAssistant1@d1c3xt`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            // case ELEMENT_TYPES.PLAN:
            //     return <Plan key={eid} config={config}/>
            case ELEMENT_TYPES.MYCALENDAR:
                return <MyCalendar ecId={`${this && this.props && this.props.ecId || ''}_MyCalendar@9ol1c0`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.UNREAD_COOPERATION:
                return <Cooperation ecId={`${this && this.props && this.props.ecId || ''}_Cooperation@xpzxij`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MEETINGCALENDAR:
                return <MeetingCalendar ecId={`${this && this.props && this.props.ecId || ''}_MeetingCalendar@zcq4qn`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MY_PROJECTS:
                return <MyProjects ecId={`${this && this.props && this.props.ecId || ''}_MyProjects@fa3m81`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.LOGIN:
                return <Login ecId={`${this && this.props && this.props.ecId || ''}_Login@4ihmeh`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.LOGIN_NEWS:
                return <LoginNews ecId={`${this && this.props && this.props.ecId || ''}_LoginNews@miicd0`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NEW_MEETING:
                return <NewMeeting ecId={`${this && this.props && this.props.ecId || ''}_NewMeeting@s0vfe0`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.DAY_PLAN:
                return <DayPlan ecId={`${this && this.props && this.props.ecId || ''}_DayPlan@zy5rkv`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MYTASK:
                return <ProcessTask ecId={`${this && this.props && this.props.ecId || ''}_ProcessTask@y36q9r`} key={eid} config={config}/>
            case ELEMENT_TYPES.UNREAD_DOCS:
                return <UnreadDocs ecId={`${this && this.props && this.props.ecId || ''}_UnreadDocs@nre53y`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NEW_CUSTOMERS:
                return <NewCustomers ecId={`${this && this.props && this.props.ecId || ''}_NewCustomers@dimfkm`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MESSAGE_REMINDING:
                return <MessageReminding ecId={`${this && this.props && this.props.ecId || ''}_MessageReminding@2om3cl`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NEW_DY:
                return <News_dy ecId={`${this && this.props && this.props.ecId || ''}_News_dy@vbyzej`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.QUICKEENTRY:
                return <QuickEntry ecId={`${this && this.props && this.props.ecId || ''}_QuickEntry@4wcp1k`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.ECODEELEMENT:
                return <EcodeElement ecId={`${this && this.props && this.props.ecId || ''}_EcodeElement@xatqvj`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.ODOCCENTER:
                return <OdocCenter ecId={`${this && this.props && this.props.ecId || ''}_OdocCenter@wbmy4r`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.RANKINGLIST:
                return <RankingList ecId={`${this && this.props && this.props.ecId || ''}_RankingList@dtw71p`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.TIMELINE:
                return<TimeLine ecId={`${this && this.props && this.props.ecId || ''}_TimeLine@q2gv1b`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
            default:
                return <NoReact ecId={`${this && this.props && this.props.ecId || ''}_NoReact@tzkvju`} key={eid} config={config} fontSizeMp={fontSizeMp}/>
        }
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/index.js